export const numberFixed = (
  number: number | null = 0,
  fixed: number = 2,
  round: "floor" | "ceil" | "round" = "floor"
) => {
  if (!number) return 0

  const multiplier = Math.pow(10, fixed)
  const flooredValue = Math[round](number * multiplier) / multiplier
  const newValue = flooredValue.toFixed(fixed)

  if (parseInt(newValue) === parseFloat(newValue)) return parseInt(newValue)

  return parseFloat(newValue)
}
